import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";

import HomePage from "./pages/HomePage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import ErrorPage from "./pages/ErrorPage";

import ProtectedRoute from "./components/admin/ProtectedRoute";

import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import GuestUsersListPage from "./pages/GuestUsersListPage";
import AddUserPage from "./pages/AddUserPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import RoleAccessPage from "./pages/RoleAccessPage";
import AssignRolePage from "./pages/AssignRolePage";
import SessionPage from "./pages/SessionPage";
import EventLocationPage from "./pages/EventLocationPage";
import GlobalLoader from "./components/common/GlobalLoader";
import LocationTypePage from "./pages/LocationTypePage";
import NotificationPage from "./pages/notification/NotificationPage";
import RatingPage from "./pages/ratings/RatingPage";
import CompanyCategoryPage from "./pages/CompanyCategory/CompanyCategoryPage";
import SponsorPage from "./pages/Sponsors/SponsorPage";
import MeetingPage from "./pages/Meetings/MeetingPage";
import MediaPage from "./pages/media/MediaPage";
import GalleryPage from "./pages/Gallery/GalleryPage";
import FloorMapPage from "./pages/FloorMap/FloorMapPage";
import HelpSosPage from "./pages/HelpSos/HelpSosPage";
import FeedbackQuestionPage from "./pages/FeedbackQuestions/FeedbackQuestionPage";
import FeedbackSubmissionPage from "./pages/FeedbackQuestions/FeedbackSubmissionPage";
import CompanyProductPage from "./pages/CompanyProduct/CompanyProductPage";
import AdsPage from "./pages/Ads/AdsPage";
import ConferenceAgendaPage from "./pages/ConferenceAgenda/ConferenceAgendaPage";
import SupportPage from "./pages/Support/SupportPage";
import UserSessionPage from "./pages/UserSession/UserSessionPage";
import ChatRequestsPage from "./pages/ChatRequests/ChatRequestsPage";
import ChatConversationPage from "./pages/ChatConversation/ChatConversationPage";
import AppDownloadPage from "./pages/DownloadApp/AppDownloadPage";
import ContentPage from "./pages/Content/ContentPage";
import PostPage from "./pages/Content/PostPage";
import ApiKeyPage from "./pages/ApiKey/ApiKeyPage";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <GlobalLoader />
      <Routes>

        {/* Default */}
        <Route path="/" element={<Navigate to="/sign-in" />} />

        {/* Public Routes */}
        <Route path="/sign-in" element={<SignInPage />} />
        {/* <Route path="/sign-up" element={<SignUpPage />} /> */}
        <Route path="/download-app" element={<AppDownloadPage />} />

        {/* Protected Routes Wrapper */}
        <Route element={<ProtectedRoute />}>

          <Route path="/dashboard" element={<HomePage />} />

          <Route exact path='/add-user' element={<AddUserPage />} />
          <Route path="/users-grid" element={<UsersGridPage />} />
          <Route path="/users-list" element={<UsersListPage />} />
          <Route path="/enquiry-list" element={<GuestUsersListPage />} />
          <Route exact path="/view-profile/:id" element={<ViewProfilePage />} />
          <Route exact path='/role-access' element={<RoleAccessPage />} />
          <Route exact path='/assign-role' element={<AssignRolePage />} />
          <Route exact path='/sessions' element={<SessionPage />} />
          <Route exact path='/event-locations' element={<EventLocationPage />} />
          <Route path="/content" element={<ContentPage />} />
          <Route path="/posts" element={<PostPage />} />
          <Route path="/sessions-type" element={<LocationTypePage />} />
          <Route path="/notifications" element={<NotificationPage />} />
          <Route path="/ratings" element={<RatingPage />} />
          <Route path="/company-category" element={<CompanyCategoryPage />} />
          <Route path="/sponsors" element={<SponsorPage />} />
          <Route path="/meetings" element={<MeetingPage />} />
          <Route path="/chat-requests" element={<ChatRequestsPage />} />
          <Route path="/media" element={<MediaPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/floor-maps" element={<FloorMapPage />} />
          <Route path="/help-desk" element={<HelpSosPage />} />
          <Route path="/feedback" element={<FeedbackQuestionPage />} />
          <Route path="/feedback-submissions" element={<FeedbackSubmissionPage />} />
          <Route path="/company-product" element={<CompanyProductPage />} />
          <Route path="/add-management" element={<AdsPage />} />
          <Route path="/conference-agenda" element={<ConferenceAgendaPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/active-users" element={<UserSessionPage />} />
          <Route path="/chat-conversations" element={<ChatConversationPage />} />
          <Route path="/api-key-generate" element={<ApiKeyPage />} />


        </Route>

        {/* 404 */}
        <Route path="*" element={<ErrorPage />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
